module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-width"
  }, [_c('div', [_c('h3', {
    staticStyle: {
      "color": "#444",
      "border-bottom": "1px solid #444"
    }
  }, [_vm._v("Video Scroller")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.url),
      expression: "value.url"
    }],
    attrs: {
      "placeholder": "Enter the video URL"
    },
    domProps: {
      "value": (_vm.value.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "url", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.thumbnail),
      expression: "value.thumbnail"
    }],
    attrs: {
      "placeholder": "Enter thumbnail URL"
    },
    domProps: {
      "value": (_vm.value.thumbnail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "thumbnail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.videoLength),
      expression: "value.videoLength"
    }],
    attrs: {
      "placeholder": "Enter the length of the video"
    },
    domProps: {
      "value": (_vm.value.videoLength)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "videoLength", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.value.items), function(html, index) {
    return _c('div', {
      key: index
    }, [_c('froala', {
      staticStyle: {
        "width": "100%",
        "margin": "0",
        "min-height": "100%",
        "margin-top": "10px"
      },
      attrs: {
        "config": _vm.froalaConfig
      },
      model: {
        value: (_vm.value.items[index]),
        callback: function($$v) {
          _vm.$set(_vm.value.items, index, $$v)
        },
        expression: "value.items[index]"
      }
    }), _vm._v(" "), _c('button', {
      staticStyle: {
        "margin": "0 auto",
        "margin-top": "10px"
      },
      on: {
        "click": function($event) {
          _vm.value.items.splice(index, 1)
        }
      }
    }, [_vm._v("Remove Text Box")])], 1)
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin": "0 auto",
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        _vm.value.items.push('')
      }
    }
  }, [_vm._v("Add Text Box")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7da7bdf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/articleWidgets/videoScroller.vue
// module id = 673
// module chunks = 1